import { DEFAULT_COLUMN_DEFS } from 'components/shared/AgTablePage/lib/constants';

/**
 * These tables are ordered by the endpoint, which sees every row. The grid only ever holds the
 * current page, so letting it run its own comparator would reorder that page against the ordering
 * the server applied. A no-op comparator keeps the header controls (they drive the query) while the
 * rows render exactly as they arrived.
 */
export const SERVER_SORTED_COL_DEF = { ...DEFAULT_COLUMN_DEFS, comparator: () => 0 };
